import { featuresData } from '@/mocks/home-data';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3 justify-center">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            平台特色
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-10 text-center">
          为什么数百万吃瓜群众选择爆料吃瓜？
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-lg p-6 border border-background-200/70 text-center group hover:border-primary-200 transition-all duration-200"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-200">
                <i className={`${feature.icon} text-2xl text-primary-500 group-hover:text-background-50 transition-colors duration-200`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}